/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Package_CanceledInputs */

const tr_geliver_substatus_package_canceled = /** @type {(inputs: Geliver_Substatus_Package_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal Edildi`)
};

const en_geliver_substatus_package_canceled = /** @type {(inputs: Geliver_Substatus_Package_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

const de_geliver_substatus_package_canceled = /** @type {(inputs: Geliver_Substatus_Package_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storniert`)
};

const ru_geliver_substatus_package_canceled = /** @type {(inputs: Geliver_Substatus_Package_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменено`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Geliver_Substatus_Package_CanceledInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_package_canceled = /** @type {((inputs?: Geliver_Substatus_Package_CanceledInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Package_CanceledInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_package_canceled(inputs)
	if (locale === "de") return de_geliver_substatus_package_canceled(inputs)
	if (locale === "ru") return ru_geliver_substatus_package_canceled(inputs)
	return tr_geliver_substatus_package_canceled(inputs)
});